import { ACCENT, MUTED, type IllustrationProps } from './types';

/**
 * IllustrationBins — empty-state art for bins (fungible holding containers).
 *
 * Depicts: an open cardboard-style bin in perspective with a small stack of
 * cards peeking over the rim.
 *
 * Resource: bins. Shell: any.
 */
export function IllustrationBins({ size = 120, className, style }: IllustrationProps) {
  const h = (size * 90) / 120;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 120 90"
      fill="none"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <ellipse cx="60" cy="82" rx="40" ry="3" stroke={MUTED} strokeWidth={1.5} />
      <path
        d="M30 38 L90 38 L84 76 L36 76 Z"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <ellipse cx="60" cy="38" rx="30" ry="6" stroke={ACCENT} strokeWidth={1.5} />
      <rect x="50" y="22" width="14" height="20" rx="1.5" stroke={MUTED} strokeWidth={1.5} />
      <rect x="58" y="18" width="14" height="22" rx="1.5" stroke={MUTED} strokeWidth={1.5} />
      <line
        x1="44"
        y1="54"
        x2="76"
        y2="54"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}
